import React from "react";
import { Link } from "react-router-dom";


function Enrollments() {
  return (
	<>
	<section className="page-head bg-cover" style={{ background: `#017efa url(${process.env.PUBLIC_URL}/assets/img/about.jpg) no-repeat` }} data-overlay="4">
				<div className="container">
					<div className="row">
						<div className="col-xl-8 col-lg-9 col-md-12">
							
							<h1 className="text-white mb-4">My Enrollments</h1>
						</div>
					</div>
				</div>
			</section>

      	<section>
				<div className="container">
					<div className="row">
	<div className="col-lg-12 col-md-12 col-sm-12">
						
							<div className="row justify-content-center">
							
								<div className="col-lg-12 col-md-12">
									<div className="light-jbs-alert mb-3">
										<div className="row justify-content-center g-3">
											<div className="col-xl-5 col-lg-4 col-md-4">
												<div className="form-group m-0">
													<input type="text" className="form-control" placeholder="Test Title" />
												</div>
											</div>
											<div className="col-xl-4 col-lg-4 col-md-4">
												<div className="form-group m-0">
													<select className="form-control form-select" >
														<option value="1">Daily Base</option>
														<option value="2">Weekly Base</option>
														<option value="3">Monthly Base</option>
														<option value="4">Anualy Base</option>
													</select>
												</div>
											</div>
											<div className="col-xl-3 col-lg-4 col-md-4">
												<div className="form-group m-0">
													<button type="button" className="btn btn-main fs-6 fw-medium full-width">Search</button>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							</div>
						
							<div className="row justify-content-center mb-4">
								<div className="col-lg-12 col-md-12">
									<div className="item-shorting-box">
										<div className="item-shorting clearfix">
											<div className="left-column"><h4 className="m-sm-0 mb-2">Showing 1 - 10 of 20 Results</h4></div>
										</div>
										<div className="item-shorting-box-right">
											<div className="shorting-by me-2 small">
												<select className="form-select" >
													<option value="0">Short by (Default)</option>
													<option value="1">Short by (Featured)</option>
													<option value="2">Short by (Urgent)</option>
													<option value="3">Short by (Post Date)</option>
												</select>
											</div>
											<div className="shorting-by small">
												<select className="form-select" >
													<option value="0">10 Per Page</option>
													<option value="1">20 Per Page</option>
													<option value="2">50 Per Page</option>
													<option value="3">10 Per Page</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							
							<div className="row justify-content-start gx-3 gy-4">
								
								
								<div className="col-xl-12 col-lg-12 col-md-12">
									<div className="jbs-list-box border">
										<div className="jbs-list-head">
											<div className="jbs-list-head-thunner">
												<div className="jbs-list-emp-thumb jbs-verified"><Link to="/"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/demo-questions.jpg`} className="img-fluid" alt="" /></figure></Link></div>
												<div className="jbs-list-job-caption">
													<div className="jbs-job-title-wrap"><h4><Link to="/" className="jbs-job-title">Demo Questions (Try me out!)</Link></h4></div>
													<div className="jbs-job-employer-wrap align-to-left"><span>10 Test . Expired On : 10 Oct 2025</span></div>
													<div className="jbs-job-employer-wrap align-to-left">Welcome to RSA! We've created a free trail with questions from our Question Bank to give you an idea of what you are accept. Go ahead and try them out!</div>
												</div>
											</div>
											<div className="jbs-list-head-last">
												<h6 className="px-4">Free</h6>
											</div>
										</div>
								
									</div>
								</div>
								
								
								<div className="col-xl-12 col-lg-12 col-md-12">
									<div className="jbs-list-box border">
										<div className="jbs-list-head">
											<div className="jbs-list-head-thunner">
												<div className="jbs-list-emp-thumb jbs-verified"><Link to="/"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/demo-questions.jpg`} className="img-fluid" alt="" /></figure></Link></div>
												<div className="jbs-list-job-caption">
													<div className="jbs-job-employer-wrap"><span>Pintrest</span></div>
													<div className="jbs-job-title-wrap"><h4><Link to="/" className="jbs-job-title">New Shopify Developer</Link></h4></div>
												</div>
											</div>
											<div className="jbs-list-head-last">
												<h6 className="px-4">Quick Apply</h6>
											</div>
										</div>
						
									</div>
								</div>
								
								
								<div className="col-xl-12 col-lg-12 col-md-12">
									<div className="jbs-list-box border">
										<div className="jbs-list-head">
											<div className="jbs-list-head-thunner">
												<div className="jbs-list-emp-thumb jbs-verified"><Link to="/"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/demo-questions.jpg`} className="img-fluid" alt="" /></figure></Link></div>
												<div className="jbs-list-job-caption">
													<div className="jbs-job-employer-wrap"><span>Shopify</span></div>
													<div className="jbs-job-title-wrap"><h4><Link to="/" className="jbs-job-title">Sr. Magento Developer</Link></h4></div>
												</div>
											</div>
											<div className="jbs-list-head-last">
												<h6 className="px-4">Quick Apply</h6>
											</div>
										</div>
					
									</div>
								</div>
								
								
								<div className="col-xl-12 col-lg-12 col-md-12">
									<div className="jbs-list-box border">
										<div className="jbs-list-head">
											<div className="jbs-list-head-thunner">
												<div className="jbs-list-emp-thumb jbs-verified"><Link to="/"><figure><img src={`${process.env.PUBLIC_URL}/assets/img/demo-questions.jpg`} className="img-fluid" alt="" /></figure></Link></div>
												<div className="jbs-list-job-caption">
													<div className="jbs-job-employer-wrap"><span>Dreezoo</span></div>
													<div className="jbs-job-title-wrap"><h4><Link to="/" className="jbs-job-title">Sr. Code Ignetor Developer</Link></h4></div>
												</div>
											</div>
											<div className="jbs-list-head-last">
												<h6 className="px-4">Quick Apply</h6>
											</div>
										</div>
										
									</div>
								</div>
								
								
							</div>
						
							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12">
									<nav aria-label="Page navigation example">
										  <ul className="pagination">
											<li className="page-item">
											  <Link className="page-link" to="#" aria-label="Previous">
												<span aria-hidden="true">&laquo;</span>
											  </Link>
											</li>
											<li className="page-item active"><Link className="page-link" to="#">1</Link></li>
											<li className="page-item"><Link className="page-link" to="#">2</Link></li>
											<li className="page-item "><Link className="page-link" to="#">3</Link></li>
											<li className="page-item"><Link className="page-link" to="#">4</Link></li>
											<li className="page-item"><Link className="page-link" to="#">5</Link></li>
											<li className="page-item"><Link className="page-link" to="#">6</Link></li>
											<li className="page-item">
											  <Link className="page-link" to="#" aria-label="Next">
												<span aria-hidden="true">&raquo;</span>
											  </Link>
											</li>
										  </ul>
									</nav>
								</div>
							</div>
					
						</div>
					</div>
				</div>
						
			</section>
  </>
  );
}
export default Enrollments;